export interface SSOUserInfo {
    uuid: string
    email: string
    first_name: string
    last_name: string
    username: string
    avatar: string | null
    phone_number: string | null
    created_on: string
    updated_on: string
    last_access: string
    email_confirmed: boolean
    language: string
    auth_token: string
}

export interface LoggedUser {
    id: number
    sso_uuid: string
    associated_on: string
    updated_on: string
    user_info: SSOUserInfo
    last_sso_sync: string
    ai_token_used: number
    ai_image_requests: number
    token_cumulative: number
    token_balance: number
}

export interface Session {
    id: number
    id_instance: number
    created: string
}

export interface Topic {
    id: number
    avatar: string
    created: string
    description: string
    title: string
}

export interface Hint {
    id: number
    id_topic: number
    created: string
    updated: string
    prompt: string
    static_response: string
    title: string
}

export interface InstanceKeys {
    graphics: {
        palette: { primary: string; secondary: string }
        chat_bg: string
        animated_header: boolean
        hide_title: boolean
    }
}

export interface Instance {
    id: number
    name: string
    description: string
    created: string
    updated: string
    keys: InstanceKeys | null
    id_organization: number
    context: string
    welcome_message: string
}

export enum IntegrationType {
    WHATSAPP = 'whatsapp',
    TELEGRAM = 'telegram',
    FACEBOOK = 'facebook',
    HEYGEN = 'heygen',
}

export interface Integration {
    active: boolean
    created: string
    id: number
    id_instance: number
    phone_number_id: string
    avatar_id?: string
    status: string | null
    token: string
    type: string
    updated: string
}

// Local data

export enum ContentType {
    Text = 'TEXT',
    Image = 'IMAGE',
}

export enum MessageType {
    Request = 'REQUEST',
    Response = 'RESPONSE',
    Loading = 'LOADING',
    Error = 'ERROR',
}

export interface HistoryMessage {
    id: number
    id_client: number
    message: string
    response: ResponseMessage
    request_date: string
    id_hint: number
    id_session: number
}

export interface ResponseMessage {
    text: string
    sourceDocuments?: unknown[]
    created: string
}

export interface ParsedMessage {
    id: string
    content: string
    contentType: ContentType
    messageType: MessageType
    datetime: number
    tokenSpent?: number
}
